// Panel-facing gRPC API (DECISIONS.md ADR-0031): real-time DDoS event
// notifications and traffic telemetry for a frontend/operator panel.
// Deliberately a SEPARATE service/listener/auth model from
// proto/nodecontrol.proto's Edge channel — panel clients authenticate with
// a JWT access token (internal/auth/internal/rbac, permissions
// "ddos.read"/"telemetry.read"), never an mTLS client certificate, and are
// served on their own listener (PanelGRPCListenAddr), never mixed with
// Edge's mTLS-required server.

// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file panel.proto (package onemcfirewall.panel.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file panel.proto.
 */
export const file_panel: GenFile = /*@__PURE__*/
  fileDesc("CgtwYW5lbC5wcm90bxIWb25lbWNmaXJld2FsbC5wYW5lbC52MSISChBTdWJzY3JpYmVSZXF1ZXN0IooCCglERG9TRXZlbnQSEQoJYXR0YWNrX2lkGAEgASgJEjUKBXN0YXRlGAIgASgOMiYub25lbWNmaXJld2FsbC5wYW5lbC52MS5ERG9TRXZlbnRTdGF0ZRIPCgdub2RlX2lkGAMgASgJEhEKCW5vZGVfbmFtZRgEIAEoCRITCgtmaWx0ZXJfbmFtZRgFIAEoCRIbChNmaWx0ZXJfa2VybmVsX2luZGV4GAYgASgNEhQKDG9ic2VydmVkX3BwcxgHIAEoARIUCgxiYXNlbGluZV9wcHMYCCABKAESFgoOdG9wX3NvdXJjZV9pcHMYCSADKAkSGQoRdGltZXN0YW1wX3VuaXhfbXMYCiABKAMi2AEKFUZpbHRlclRyYWZmaWNTbmFwc2hvdBIPCgdub2RlX2lkGAEgASgJEhEKCW5vZGVfbmFtZRgCIAEoCRITCgtmaWx0ZXJfbmFtZRgDIAEoCRIbChNmaWx0ZXJfa2VybmVsX2luZGV4GAQgASgNEgsKA3BwcxgFIAEoARILCgNicHMYBiABKAESGQoRZHJvcHBlZF9yYXRlbGltaXQYByABKAQSGQoRZHJvcHBlZF9iYW5kd2lkdGgYCCABKAQSGQoRbmV3X3NvdXJjZXNfY291bnQYCSABKAQibAoPVHJhZmZpY1NuYXBzaG90EhkKEXRpbWVzdGFtcF91bml4X21zGAEgASgDEj4KB2ZpbHRlcnMYAiADKAsyLS5vbmVtY2ZpcmV3YWxsLnBhbmVsLnYxLkZpbHRlclRyYWZmaWNTbmFwc2hvdCpoCg5ERG9TRXZlbnRTdGF0ZRIgChxERE9TX0VWRU5UX1NUQVRFX1VOU1BFQ0lGSUVEEAASGgoWRERPU19FVkVOVF9TVEFURV9TVEFSVBABEhgKFERET1NfRVZFTlRfU1RBVEVfRU5EEAIy3QEKDFBhbmVsQ29udHJvbBJkChNTdWJzY3JpYmVERG9TRXZlbnRzEigub25lbWNmaXJld2FsbC5wYW5lbC52MS5TdWJzY3JpYmVSZXF1ZXN0GiEub25lbWNmaXJld2FsbC5wYW5lbC52MS5ERG9TRXZlbnQwARJnChBTdWJzY3JpYmVUcmFmZmljEigub25lbWNmaXJld2FsbC5wYW5lbC52MS5TdWJzY3JpYmVSZXF1ZXN0Gicub25lbWNmaXJld2FsbC5wYW5lbC52MS5UcmFmZmljU25hcHNob3QwAUI3WjVnaXRodWIuY29tL2wyc3RhY2svb25lbWNmaXJld2FsbC9pbnRlcm5hbC9ycGMvcGFuZWxwYmIGcHJvdG8z");

/**
 * SubscribeRequest is empty today — both streams cover the whole fleet.
 * Reserved for future per-node/per-filter scoping without a wire-format
 * break.
 *
 * @generated from message onemcfirewall.panel.v1.SubscribeRequest
 */
export type SubscribeRequest = Message<"onemcfirewall.panel.v1.SubscribeRequest"> & {
};

/**
 * Describes the message onemcfirewall.panel.v1.SubscribeRequest.
 * Use `create(SubscribeRequestSchema)` to create a new message.
 */
export const SubscribeRequestSchema: GenMessage<SubscribeRequest> = /*@__PURE__*/
  messageDesc(file_panel, 0);

/**
 * DDoSEvent is one state transition of one detected anomaly (DECISIONS.md
 * ADR-0029). attack_id is stable across the START and matching END event
 * for the same incident.
 *
 * @generated from message onemcfirewall.panel.v1.DDoSEvent
 */
export type DDoSEvent = Message<"onemcfirewall.panel.v1.DDoSEvent"> & {
  /**
   * @generated from field: string attack_id = 1;
   */
  attackId: string;

  /**
   * @generated from field: onemcfirewall.panel.v1.DDoSEventState state = 2;
   */
  state: DDoSEventState;

  /**
   * "" = Master itself
   *
   * @generated from field: string node_id = 3;
   */
  nodeId: string;

  /**
   * @generated from field: string node_name = 4;
   */
  nodeName: string;

  /**
   * e.g. "minecraft-java", "default"
   *
   * @generated from field: string filter_name = 5;
   */
  filterName: string;

  /**
   * @generated from field: uint32 filter_kernel_index = 6;
   */
  filterKernelIndex: number;

  /**
   * packets/sec at the moment of this transition
   *
   * @generated from field: double observed_pps = 7;
   */
  observedPps: number;

  /**
   * the learned baseline at that moment
   *
   * @generated from field: double baseline_pps = 8;
   */
  baselinePps: number;

  /**
   * bounded, e.g. top 20
   *
   * @generated from field: repeated string top_source_ips = 9;
   */
  topSourceIps: string[];

  /**
   * @generated from field: int64 timestamp_unix_ms = 10;
   */
  timestampUnixMs: bigint;
};

/**
 * Describes the message onemcfirewall.panel.v1.DDoSEvent.
 * Use `create(DDoSEventSchema)` to create a new message.
 */
export const DDoSEventSchema: GenMessage<DDoSEvent> = /*@__PURE__*/
  messageDesc(file_panel, 1);

/**
 * TrafficSnapshot is one poll tick's aggregated view, per (node, filter) —
 * DECISIONS.md ADR-0029/ADR-0031.
 *
 * @generated from message onemcfirewall.panel.v1.FilterTrafficSnapshot
 */
export type FilterTrafficSnapshot = Message<"onemcfirewall.panel.v1.FilterTrafficSnapshot"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;

  /**
   * @generated from field: string node_name = 2;
   */
  nodeName: string;

  /**
   * @generated from field: string filter_name = 3;
   */
  filterName: string;

  /**
   * @generated from field: uint32 filter_kernel_index = 4;
   */
  filterKernelIndex: number;

  /**
   * @generated from field: double pps = 5;
   */
  pps: number;

  /**
   * @generated from field: double bps = 6;
   */
  bps: number;

  /**
   * @generated from field: uint64 dropped_ratelimit = 7;
   */
  droppedRatelimit: bigint;

  /**
   * @generated from field: uint64 dropped_bandwidth = 8;
   */
  droppedBandwidth: bigint;

  /**
   * @generated from field: uint64 new_sources_count = 9;
   */
  newSourcesCount: bigint;
};

/**
 * Describes the message onemcfirewall.panel.v1.FilterTrafficSnapshot.
 * Use `create(FilterTrafficSnapshotSchema)` to create a new message.
 */
export const FilterTrafficSnapshotSchema: GenMessage<FilterTrafficSnapshot> = /*@__PURE__*/
  messageDesc(file_panel, 2);

/**
 * @generated from message onemcfirewall.panel.v1.TrafficSnapshot
 */
export type TrafficSnapshot = Message<"onemcfirewall.panel.v1.TrafficSnapshot"> & {
  /**
   * @generated from field: int64 timestamp_unix_ms = 1;
   */
  timestampUnixMs: bigint;

  /**
   * @generated from field: repeated onemcfirewall.panel.v1.FilterTrafficSnapshot filters = 2;
   */
  filters: FilterTrafficSnapshot[];
};

/**
 * Describes the message onemcfirewall.panel.v1.TrafficSnapshot.
 * Use `create(TrafficSnapshotSchema)` to create a new message.
 */
export const TrafficSnapshotSchema: GenMessage<TrafficSnapshot> = /*@__PURE__*/
  messageDesc(file_panel, 3);

/**
 * @generated from enum onemcfirewall.panel.v1.DDoSEventState
 */
export enum DDoSEventState {
  /**
   * @generated from enum value: DDOS_EVENT_STATE_UNSPECIFIED = 0;
   */
  DDOS_EVENT_STATE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: DDOS_EVENT_STATE_START = 1;
   */
  DDOS_EVENT_STATE_START = 1,

  /**
   * @generated from enum value: DDOS_EVENT_STATE_END = 2;
   */
  DDOS_EVENT_STATE_END = 2,
}

/**
 * Describes the enum onemcfirewall.panel.v1.DDoSEventState.
 */
export const DDoSEventStateSchema: GenEnum<DDoSEventState> = /*@__PURE__*/
  enumDesc(file_panel, 0);

/**
 * @generated from service onemcfirewall.panel.v1.PanelControl
 */
export const PanelControl: GenService<{
  /**
   * SubscribeDDoSEvents streams DDoS start/end notifications as
   * internal/ddossensor's adaptive baseline detects them (DECISIONS.md
   * ADR-0029). One event per state transition, never a per-packet feed.
   *
   * @generated from rpc onemcfirewall.panel.v1.PanelControl.SubscribeDDoSEvents
   */
  subscribeDDoSEvents: {
    methodKind: "server_streaming";
    input: typeof SubscribeRequestSchema;
    output: typeof DDoSEventSchema;
  },
  /**
   * SubscribeTraffic streams periodic, already-aggregated traffic
   * snapshots (one per internal/ddossensor poll tick) — never per-packet.
   * The sender uses replace-with-latest channel semantics (DECISIONS.md
   * ADR-0031) so this stream stays smooth even during a real DDoS: a slow
   * subscriber only ever misses intermediate samples, never falls behind
   * indefinitely or gets disconnected for it.
   *
   * @generated from rpc onemcfirewall.panel.v1.PanelControl.SubscribeTraffic
   */
  subscribeTraffic: {
    methodKind: "server_streaming";
    input: typeof SubscribeRequestSchema;
    output: typeof TrafficSnapshotSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_panel, 0);

